/**
 * Set a custom name for a datadog action. Use to prevent sensitive information such attendee names being sent to
 * datadog.
 * @see https://docs.datadoghq.com/real_user_monitoring/browser/tracking_user_actions/#declare-a-name-for-click-actions
 * @param actionName
 */
const injectCustomDatadogActionName = (actionName: string) => ({
  'data-dd-action-name': actionName
});
export default injectCustomDatadogActionName;
